/** Lab marketing surfaces use `rank` for display order (lower renders first). */
export function getLabItemsSortedByRank<T extends { rank: number }>(items: Array<T> | undefined): Array<T> {
  if (!items?.length) {
    return []
  }

  return items.slice().sort((left, right) => left.rank - right.rank)
}

export function getFirstEligibleLabItemByRank<T extends { rank: number }>(
  items: Array<T> | undefined,
  isEligible: (item: T) => boolean,
): T | undefined {
  return getLabItemsSortedByRank(items).find(isEligible)
}
